import { Alert, Button, Form, Input, Select } from "antd";
import { FormInstance } from "antd/lib/form";
import * as React from "react";
import { createRef, useEffect, useState } from "react";
import { AccountBean, TimeZoneBean } from "src/api/api";
import accountApi from "./AccountApi";
import { formDataLoader, FormDataType } from "../../../util/FormDataLoader";
import { useHistory } from "react-router";

const FormItem = Form.Item;
const Option = Select.Option;

interface Props {}

const formInfoItems: FormDataType[] = [FormDataType.TimeZones];

export const AccountCreate: React.FC<Props> = () => {
  const formRef = createRef<FormInstance>();
  const history = useHistory();
  const [error, setError] = useState();
  const [info, setInfo] = useState({
    timezones: [],
  });
  const [roleState, setRole] = useState<AccountBean.RoleEnum>();

  const handleSubmit = () => {
    formRef.current?.validateFields().then((values) => {
      accountApi
        .create({ ...values })
        .then(history.goBack)
        .catch((er) => {
          setError(er.error);
        });
    });
  };

  const loadData = async () => {
    try {
      let formInfo = await formDataLoader(...formInfoItems);
      setInfo(formInfo as any);
    } catch (e) {
      onRejected(e);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  const onRejected = (err) => {
    setError(err.error);
  };

  const handleRoleChange = (value) => {
    setRole(value);
  };

  return (
    <Form
      style={{ maxWidth: "1000px" }}
      onFinish={handleSubmit}
      ref={formRef}
      labelCol={{ span: 5 }}
      wrapperCol={{ span: 19 }}
    >
      {error ? <Alert message={error} type="error" /> : null}
      <FormItem
        name="username"
        rules={[{ required: true, message: "Please input Account name" }]}
        label="Name"
      >
        <Input />
      </FormItem>
      <FormItem
        name="email"
        rules={[{ required: true, message: "Please input Account email" }]}
        label="Email"
      >
        <Input />
      </FormItem>
      <FormItem
        name="role"
        rules={[{ required: true, message: "Please select Account Role" }]}
        label="Role"
      >
        <Select
          disabled={
            roleState == AccountBean.RoleEnum.Publisher ||
            roleState == AccountBean.RoleEnum.Dsp
          }
          onChange={handleRoleChange}
          placeholder="Select Role"
        >
          <Option
            key={AccountBean.RoleEnum.Admin}
            value={AccountBean.RoleEnum.Admin}
          >
            {AccountBean.RoleEnum.Admin}
          </Option>
          <Option
            key={AccountBean.RoleEnum.Reporting}
            value={AccountBean.RoleEnum.Reporting}
          >
            {AccountBean.RoleEnum.Reporting}
          </Option>
        </Select>
      </FormItem>
      <FormItem
        name="walletId"
        label="Wallet ID"
        rules={[
          {
            pattern: new RegExp("^\\s*0x\\S*\\s*$"),
            message: "Please input correct Wallet ID",
          },
        ]}
      >
        <Input />
      </FormItem>
      <FormItem
        name="timezoneId"
        rules={[
          {
            required: true,
            message: "Please select Time Zone",
            type: "string",
          },
        ]}
        label="Time Zone"
      >
        <Select showSearch placeholder="Select time zone">
          {info.timezones.map((timezone: TimeZoneBean) => (
            <Option key={timezone.id} value={timezone.id as string}>
              {timezone.id}
            </Option>
          ))}
        </Select>
      </FormItem>
      <FormItem
        name="password"
        label="Password"
        rules={[
          { required: true, message: "Please enter password" },
          {
            pattern: new RegExp(
              "(?=.*[0-9])(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z!@#$%^&*]{12,}"
            ),
            message:
              "Use 12 characters or more for your password. It should include at least one character from each group: a-z, A-Z, 0-9, !@#$%^&*",
          },
          {
            max: 255,
            message: "Password cannot be longer that 255 characters",
          },
        ]}
      >
        <Input autoComplete="new-password" type="password" />
      </FormItem>
      <FormItem wrapperCol={{ offset: 11, span: 6 }}>
        <Button
          style={{ width: "45%", margin: "0 2%" }}
          type="primary"
          htmlType="submit"
        >
          Save
        </Button>
        <Button
          style={{ width: "45%", margin: "0 2%" }}
          type="primary"
          danger
          htmlType="button"
          onClick={history.goBack}
        >
          Cancel
        </Button>
      </FormItem>
    </Form>
  );
};

export default AccountCreate;
